import { configureStore } from '@reduxjs/toolkit';
import themeReducer from './theme';
import authReducer from './auth';
import hourReducer from './hour';

const store = configureStore({
    reducer: { auth: authReducer, theme: themeReducer, hour: hourReducer },
});

export default store;